import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  ChannelList,
  Channel,
  Window,
  Thread,
  useChannelActionContext,
  VirtualizedMessageList,
} from 'stream-chat-react';
import { LayoutStage } from './StreamChat';
import { ChannelSearch } from './ChannelSearch';
import { CustomChannelPreview } from './CustomChannelPreview';
import CustomChannelHeader from './CustomChannelHeader';
import CustomMessageInput from './CustomMessageInput';
import StreamSearchPanel from './StreamSearchPanel';
import { getLatestMessagePreview } from './ChatUtils';
import { ChannelFilters, ChannelOptions, ChannelSort } from 'stream-chat';
import ChannelLayoutManager from './ChannelLayoutManager';

function StreamChatChannel({
  activeView,
  setActiveView,
}: {
  activeView: LayoutStage;
  setActiveView: Dispatch<SetStateAction<LayoutStage>>;
}) {
  const { jumpToMessage } = useChannelActionContext();
  const [jumpToMessageId, setJumpToMessageId] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (jumpToMessageId && activeView === 'channel') {
      void jumpToMessage(jumpToMessageId);
    }

    if (activeView !== 'channel') {
      setJumpToMessageId(undefined);
    }
  }, [activeView]);

  return (
    <>
      {activeView === 'channel' && (
        <Window>
          <CustomChannelHeader setLayout={setActiveView} />
          <VirtualizedMessageList />
          <CustomMessageInput />
        </Window>
      )}
      {activeView === 'thread' && <Thread autoFocus={false} additionalMessageInputProps={{ minRows: 1, maxRows: 6 }} />}
      {activeView === 'search' && <StreamSearchPanel setLayout={setActiveView} setId={setJumpToMessageId} />}
    </>
  );
}

export default function StreamChatBodyPhone({
  layout,
  filters,
  sort,
  options,
  setLayout,
}: {
  layout: LayoutStage;
  filters: ChannelFilters;
  sort: ChannelSort;
  options: ChannelOptions;
  setLayout: Dispatch<SetStateAction<LayoutStage>>;
}) {
  return (
    <div className="mobile-chat-container">
      <div style={{ display: layout !== 'list' ? 'none' : 'block' }}>
        <ChannelSearch />
        <ChannelList
          Preview={(props) => <CustomChannelPreview {...props} />}
          getLatestMessagePreview={getLatestMessagePreview}
          filters={filters}
          sort={sort}
          options={options}
          setActiveChannelOnMount={false}
        />
      </div>
      <Channel>
        <ChannelLayoutManager layout={layout} setLayout={setLayout}>
          <StreamChatChannel activeView={layout} setActiveView={setLayout} />
        </ChannelLayoutManager>
      </Channel>
    </div>
  );
}
